<template>
  <body id="paper">
  <el-form class="login-container" label-position="left" label-width="0px">
    <h3 class="login_title">系统登录</h3>
    <el-form-item>
      <el-input type="text" v-model="loginForm.username"
                auto-complete="off" placeholder="手机号"></el-input>
                <button>获取验证码</button>
    </el-form-item>
   
    <el-form-item>
      <el-input type="password" v-model="loginForm.password"
                auto-complete="off" placeholder="验证码"></el-input>
    </el-form-item>
    <el-form-item style="width: 100%">
      <el-button type="primary" style="width: 100%;background: #505458;border: none" v-on:click="login">注册/登录</el-button>
      <!-- <router-link to="register"><el-button type="primary" style="width: 40%;background: #505458;border: none">注册</el-button></router-link> -->
    </el-form-item>
  </el-form>
  </body>
</template>

<script>
  export default {
    name: 'Login',
    data() {
      return {
        loginForm: {
          // 默认账号和密码
          // username: '',
          // password: ''
        },
        responseResult: []
      }
    },
    methods: {
      login() {

        if(window.localStorage){ //兼容
          console.log(new Date().getTime())
          window.localStorage.setItem('user_expires_date', new Date().getTime())
          console.log(window.localStorage.getItem('user_expires_date') - 10000)
        }


        var _this = this
      //  console.log(this.$store.state)
        this.$axios
          .post('/login', {
            username: this.loginForm.username,
            password: this.loginForm.password
          })
          .then(successResponse => {
            console.log("successResponse: ",successResponse)
            if (successResponse.data.code === 200) {
              _this.$store.commit('login',successResponse.data.data)
              _this.$router.push({path: '/home'})
            }else {
              _this.$store.commit('logout')
              _this.$router.replace({path: '/index'})
            }
          })
          .catch(failResponse => {
            console.log(failResponse.toString())
          })
      }
    }
  }
</script>

<style>
  .login-container {
    border-radius: 15px;
    background-clip: padding-box;
    margin: 90px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }

  .login_title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
  #paper {
    background: url("../assets/eva.jpg") no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: cover;
    position: fixed;
  }
  body {
    margin: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue